import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'rp:overview',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'rp.overview.widgets.metrics',
                        },
                      },
                    },
                    span: 3,
                  },
                  {
                    content: {
                      column: {
                        elements: [
                          {
                            content: {
                              row: {
                                elements: [
                                  {
                                    content: {
                                      widget: {
                                        widget: {
                                          alias: 'rp.overview.widgets.trends',
                                        },
                                      },
                                    },
                                    span: 4,
                                  },
                                  {
                                    content: {
                                      widget: {
                                        widget: {
                                          alias: 'rp.overview.widgets.donut',
                                        },
                                      },
                                    },
                                    span: 4,
                                  },
                                ],
                              },
                            },
                            height: 400,
                          },
                          {
                            content: {
                              widget: {
                                widget: {
                                  alias:
                                    'rp.overview.widgets.department-performance-scatter',
                                },
                              },
                            },
                            height: 400,
                          },
                        ],
                      },
                    },
                    span: 8,
                  },
                ],
              },
            },
            height: 800,
          },
        ],
      },
    },
    description:
      'Research Performance Overview Page (Alternate: Departments Scatter)',
    name: 'rp.overview.dept',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
